/**
 * @generated SignedSource<<3b8bfce76673921c222ddcef4f7d13f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useContextualEmojiUserPreferencesFragment$data = {
  readonly contextualEmojiOptOut: boolean | null | undefined;
  readonly " $fragmentType": "useContextualEmojiUserPreferencesFragment";
};
export type useContextualEmojiUserPreferencesFragment$key = {
  readonly " $data"?: useContextualEmojiUserPreferencesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useContextualEmojiUserPreferencesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useContextualEmojiUserPreferencesFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "contextualEmojiOptOut"
    }
  ],
  "type": "UserPreferences"
};

(node as any).hash = "9fb2a4172ed2114c289df4aae3f26325";

export default node;
